'use client'

import { Spacer, Text } from '@vinted/web-ui'
import { useIntl } from 'react-intl'

import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'
import { formatCurrencyAmount } from '@marketplace-web/currency/currency-data'
import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'

import DetailedPriceBreakdown from './DetailedPriceBreakdown'
import BundleFooterPricingSkeleton from './BundleFooterPricingSkeleton'

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel | undefined
  selectedItems: Array<ProductItemModel>
  isBundleSummaryLoading: boolean
  escrowNoteTranslationKey?: string
}

const BundleFooterPricing = ({
  bundleSummary,
  isSellerBusiness,
  selectedItems,
  isBundleSummaryLoading,
  escrowNoteTranslationKey,
}: Props) => {
  const { locale } = useIntl()

  if (isBundleSummaryLoading) {
    return <BundleFooterPricingSkeleton />
  }

  if (!bundleSummary) return null

  const { price, discountApplied, fullPrice } = bundleSummary

  return (
    <div className="u-flexbox u-flex-direction-column u-flex-none">
      <div className="u-flexbox u-flex-direction-row">
        {discountApplied && (
          <>
            <Text
              as="h3"
              text={formatCurrencyAmount(price, locale)}
              type="subtitle"
              theme="muted"
              testId="bundle-footer-discounted-price"
            />
            <Spacer orientation="vertical" size="small" />
          </>
        )}
        <Text
          as="h3"
          text={formatCurrencyAmount(fullPrice, locale)}
          type="subtitle"
          theme="muted"
          strikethrough={discountApplied}
          testId="bundle-footer-full-price"
        />
      </div>
      <DetailedPriceBreakdown
        bundleSummary={bundleSummary}
        isSellerBusiness={isSellerBusiness}
        selectedItems={selectedItems}
        escrowNoteTranslationKey={escrowNoteTranslationKey}
      />
    </div>
  )
}

export default BundleFooterPricing
